<template>
  <div class="ai-confirm" :class="{ danger: destructive }" role="alertdialog" aria-labelledby="ai-confirm-title">
    <div class="ai-confirm-head">
      <span class="ai-confirm-icon">
        <i :class="destructive ? 'fas fa-exclamation-triangle' : 'fas fa-bolt'"></i>
      </span>
      <div>
        <div class="ai-confirm-kicker">Confirmation requise</div>
        <div id="ai-confirm-title" class="ai-confirm-title">{{ title }}</div>
      </div>
    </div>

    <dl v-if="summary.length" class="ai-confirm-summary">
      <div v-for="item in summary" :key="item.label" class="ai-confirm-row">
        <dt>{{ item.label }}</dt>
        <dd>{{ item.value }}</dd>
      </div>
    </dl>

    <div class="ai-confirm-actions">
      <button type="button" class="ai-confirm-cancel" :disabled="busy" @click="$emit('cancel')">Annuler</button>
      <button ref="confirmButton" type="button" class="ai-confirm-ok" :disabled="busy" @click="$emit('confirm')">
        <i class="fas fa-check"></i> Confirmer
      </button>
    </div>
  </div>
</template>

<script>
import { toolLabel, confirmationSummary, isDestructiveTool } from './assistant-format';

export default {
  name: 'AssistantConfirm',
  props: {
    pending: { type: Object, required: true },
    busy: { type: Boolean, default: false },
  },
  emits: ['confirm', 'cancel'],
  computed: {
    title() {
      return toolLabel(this.pending.toolName);
    },
    summary() {
      return confirmationSummary(this.pending.toolArguments);
    },
    destructive() {
      return isDestructiveTool(this.pending.toolName);
    },
  },
};
</script>

<style scoped>
.ai-confirm {
  --confirm-accent: var(--ai-primary);
  --confirm-soft: var(--ai-primary-soft);
  margin: 0 12px 10px;
  padding: 14px;
  border: 1px solid var(--ai-primary-line);
  border-radius: 14px;
  background: var(--ai-surface);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);
}

.ai-confirm.danger {
  --confirm-accent: #e11d48;
  --confirm-soft: #fff1f2;
  border-color: #fecdd3;
}

.ai-confirm-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-confirm-icon {
  flex: 0 0 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--confirm-soft);
  color: var(--confirm-accent);
  display: grid;
  place-items: center;
  font-size: 13px;
}

.ai-confirm-kicker {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ai-faint);
}

.ai-confirm-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--ai-ink);
}

.ai-confirm-summary {
  display: grid;
  gap: 6px;
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--ai-soft);
}

.ai-confirm-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
}

.ai-confirm-row dt {
  font-weight: 500;
  color: var(--ai-muted);
}

.ai-confirm-row dd {
  margin: 0;
  font-weight: 600;
  color: var(--ai-ink);
  text-align: right;
  overflow-wrap: anywhere;
}

.ai-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.ai-confirm-cancel,
.ai-confirm-ok {
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 140ms var(--ai-ease), filter 140ms ease;
}

.ai-confirm-cancel {
  border: 1px solid var(--ai-line-strong);
  background: var(--ai-surface);
  color: #334155;
}

.ai-confirm-ok {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: var(--confirm-accent);
  color: #fff;
}

.ai-confirm-ok:hover:not(:disabled) {
  filter: brightness(1.08);
}

.ai-confirm-cancel:active,
.ai-confirm-ok:active {
  transform: scale(0.97);
}

.ai-confirm-cancel:disabled,
.ai-confirm-ok:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
